/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

function plural(n: number): number {
  return 5;
}

export default [
  'bo-IN',
  [
    ['སྔ་དྲོ་', 'ཕྱི་དྲོ་'],
    ,
  ],
  ,
  [
    ['ཉི', 'ཟླ', 'མིག', 'ལྷག', 'ཕུར', 'སངས', 'སྤེན'],
    [
      'ཉི་མ་', 'ཟླ་བ་', 'མིག་དམར་', 'ལྷག་པ་',
      'ཕུར་བུ་', 'པ་སངས་', 'སྤེན་པ་'
    ],
    [
      'གཟའ་ཉི་མ་', 'གཟའ་ཟླ་བ་',
      'གཟའ་མིག་དམར་', 'གཟའ་ལྷག་པ་',
      'གཟའ་ཕུར་བུ་', 'གཟའ་པ་སངས་',
      'གཟའ་སྤེན་པ་'
    ],
    [
      'ཉི་མ་', 'ཟླ་བ་', 'མིག་དམར་', 'ལྷག་པ་',
      'ཕུར་བུ་', 'པ་སངས་', 'སྤེན་པ་'
    ]
  ],
  ,
  [
    ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
    [
      'ཟླ་༡', 'ཟླ་༢', 'ཟླ་༣', 'ཟླ་༤', 'ཟླ་༥',
      'ཟླ་༦', 'ཟླ་༧', 'ཟླ་༨', 'ཟླ་༩', 'ཟླ་༡༠',
      'ཟླ་༡༡', 'ཟླ་༡༢'
    ],
    [
      'ཟླ་བ་དང་པོ', 'ཟླ་བ་གཉིས་པ',
      'ཟླ་བ་གསུམ་པ', 'ཟླ་བ་བཞི་པ',
      'ཟླ་བ་ལྔ་པ', 'ཟླ་བ་དྲུག་པ',
      'ཟླ་བ་བདུན་པ', 'ཟླ་བ་བརྒྱད་པ',
      'ཟླ་བ་དགུ་པ', 'ཟླ་བ་བཅུ་པ',
      'ཟླ་བ་བཅུ་གཅིག་པ',
      'ཟླ་བ་བཅུ་གཉིས་པ'
    ]
  ],
  [
    ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
    [
      'ཟླ་༡', 'ཟླ་༢', 'ཟླ་༣', 'ཟླ་༤', 'ཟླ་༥',
      'ཟླ་༦', 'ཟླ་༧', 'ཟླ་༨', 'ཟླ་༩', 'ཟླ་༡༠',
      'ཟླ་༡༡', 'ཟླ་༡༢'
    ],
    [
      'ཟླ་བ་དང་པོ་', 'ཟླ་བ་གཉིས་པ་',
      'ཟླ་བ་གསུམ་པ་', 'ཟླ་བ་བཞི་པ་',
      'ཟླ་བ་ལྔ་པ་', 'ཟླ་བ་དྲུག་པ་',
      'ཟླ་བ་བདུན་པ་', 'ཟླ་བ་བརྒྱད་པ་',
      'ཟླ་བ་དགུ་པ་', 'ཟླ་བ་བཅུ་པ་',
      'ཟླ་བ་བཅུ་གཅིག་པ་',
      'ཟླ་བ་བཅུ་གཉིས་པ་'
    ]
  ],
  [
    ['སྤྱི་ལོ་སྔོན་', 'སྤྱི་ལོ་'],
    ,
  ],
  0, [0, 0],
  [
    'y-MM-dd', 'y ལོའི་MMMཚེས་d',
    'སྤྱི་ལོ་y MMMMའི་ཚེས་d', 'y MMMMའི་ཚེས་d, EEEE'
  ],
  ['h:mm a', 'h:mm:ss a', 'h:mm:ss a z', 'h:mm:ss a zzzz'],
  [
    '{1} {0}',
    ,
    ,
  ],
  ['.', ',', ';', '%', '+', '-', 'E', '×', '‰', '∞', 'NaN', ':'],
  ['#,##0.###', '#,##0%', '¤ #,##0.00', '#E0'], '₹', 'རྒྱ་གར་སྒོར་',
  plural
];
